
import { defineComponent } from 'vue';
import Modal from '@/components/modals/Modal.vue';
import BundleCreateForm from '@/components/bundles/BundleCreateForm.vue';

export default defineComponent({
  name: 'bundle-create-modal',
  emits: ['update:modelValue', 'formSubmitted', 'close'],
  props: {
    modelValue: { type: Boolean, default: false },
  },
  components: {
    Modal,
    BundleCreateForm,
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
  methods: {
    handleDataSubmitted() {
      this.$emit('formSubmitted');
    },

    handleClose() {
      this.$emit('close');
    },
  },
});
